"use strict";
/**
 * Created by Ning Jiang on 1/18/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StillImageBgIntroView = void 0;
const GameIntroView_1 = require("../../core/gameintro/GameIntroView");
const GameResources_1 = require("../../core/resource/GameResources");
const UserAgent_1 = require("../../core/useragent/UserAgent");
class StillImageBgIntroView extends GameIntroView_1.GameIntroView {
    constructor(config) {
        super(config);
        this._backgroundTextures = config.backgroundTextures;
    }
    createBackground() {
        const background = new PIXI.Sprite();
        background.anchor.set(0.5, 0.5);
        return background;
    }
    onResizeBackground(resizeData) {
        const background = this._background;
        background.texture = GameResources_1.GameResources.getTextures(UserAgent_1.UserAgent.getDeviceDependentValue(this._backgroundTextures))[0];
        background.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        const scale = Math.max(this._screenWidth / background.texture.width, this._screenHeight / background.texture.height);
        background.scale.set(scale, scale);
    }
}
exports.StillImageBgIntroView = StillImageBgIntroView;
//# sourceMappingURL=StillImageBgIntroView.js.map